// extracted by mini-css-extract-plugin
export var PartnersWrapper = "Partners-module--PartnersWrapper--1TQ5Z";
export var CustomParagraph = "Partners-module--CustomParagraph--2Gkvv";